import React from 'react'
import { Redirect } from 'react-router-dom'
import { ImageContent } from '../shared/glamorous-style'
import PropTypes from 'prop-types'
import ImageList from '../shared/image-list'
import glamorous from 'glamorous'
import GiftOfChoice from '../gift-of-choice'
import { graphql, withApollo } from 'react-apollo'
import getAllCategories from '../../graphql/getAllCategories'
import { trackImpression } from '../../utils/analytics'
import { handleSessionError } from '../../utils/error-tracking'
import { flowRight as compose } from 'lodash'
import { Message } from '@paypalcorp/worldready-react'

const Title = glamorous.h1({
  fontSize: '30px',
  color: '#4a4a4a',
  textAlign: 'center',
  margin: 'auto',
  paddingTop: '36px',
  paddingBottom: '36px',
})

export class Categories extends React.Component {
  static propTypes = {
    data: PropTypes.shape({
      loading: PropTypes.bool,
      error: PropTypes.object,
      getAllCategories: PropTypes.array,
    }).isRequired,
    client: PropTypes.object,
  }

  componentDidMount() {
    this.props.client.writeData({ data: { onReviewPage: false } })

    trackImpression(
      'main:consumer:gifts:home:',
      'main:consumer:gifts:home:categories:::',
    )
  }

  render() {
    if (this.props.data.loading) {
      return (
        <div className="vx_has-spinner-large" style={{ paddingTop: '400px' }} />
      )
    }
    if (this.props.data.error) {
      handleSessionError(this.props.data.error)
      return <Redirect to="/error" />
    }

    const categories = this.props.data.getAllCategories

    return (
      <div id="choose-a-category">
        <Title className="vx_text-2">
          <Message id="pages/categories.categories.header" />
        </Title>
        <div id="content-wrapper" style={{ textAlign: 'center' }}>
          <ImageContent>
            <ImageList items={categories} />
          </ImageContent>
        </div>
        <GiftOfChoice parentPage="categories" />
      </div>
    )
  }
}

const CategoriesWithData = compose(
  withApollo,
  graphql(getAllCategories),
)(Categories)

export default CategoriesWithData
